import CryptoJS from 'crypto-js';
const secretKey =
  process.env.QRCODE_DECODE_SECRET_KEY ||
  process.env.NEXT_PUBLIC_QRCODE_DECODE_SECRET_KEY ||
  '';

export const encryptQuery = (query: string) => {
  const ciphertext = CryptoJS.AES.encrypt(query, secretKey).toString();
  return ciphertext;
};

export const decryptQuery = (encryptedQuery: string) => {
  try {
    const decodedQuery = decodeURIComponent(encryptedQuery);
    const bytes = CryptoJS.AES.decrypt(decodedQuery, secretKey);
    const decryptedQuery = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedQuery;
  } catch (error) {
    console.error('Error decoding or decrypting the query:', error);
    return '';
  }
};
